import React from 'react';

import Icon from "core/ui-kit/icon";

import { IconNames } from "core/ui-kit/icon/constants";

const DeveloperIcons = () => {

    const iconNames = Object.keys(IconNames);

    return (
        <div className="rt--icons">
            <div className="rt--icons-grid">
                {iconNames.map(name => (
                    <div key={name} className="rt--icons-item">
                        <Icon name={name} size={32}/>
                        <div className="rt--icons-name">{name}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default DeveloperIcons;